export default {
  tr: {
    /* Start Transaction - History */
    AccountNo: 'Hesap Numarası',
    TransactionStatus: 'İşlem Durumu',
    CustomerFee:'Müşteri Ücreti',
    ProviderFee:'Sağlayıcı Ücreti',
    /* End Transaction - History */

    /* Account Order List */
    PositionID: 'Ticket',
    Login: 'Giriş ID',
    Symbol: 'Sembol',
    Digits: 'Hane',
    OpenAction: 'CMD',
    Volume: 'Lot',
    OpenTime: 'Açılış Zamanı',
    PricePosition: 'Açılış Fiyatı',
    PriceSL: 'Kayıp Durdurmak',
    PriceTP: 'Kar Almak',
    Time: 'Kapanış Zamanı',
    Commission: 'Komisyon',
    Price: 'Kapanış Fiyatı',
    Profit: 'Kar',
    Storage:'Swap',
    
    
    /* End Account Order List */

    /* Accounts Password */
    ChangeMTPassword: 'Meta Trader Şifre Değiştir',
    ServerType: 'Server Türü',
    ChangeMasterPassword: 'Ana Şifreyi Değiştir',
    ChangeInverstorPassword:'Sadece İzleme Şifresini Değiştir',
    /* End Accounts Password */

    /* Accounts Recharge demo account */
    RechargeDemoAccount: 'Demo Hesabına Para Yükle',
    /* End Accounts Recharge demo account */

    /* Accounts Leverage */
    ChangeLeverage: 'Kaldıracı Değiştir',
    /* End Accounts Leverage */


    transactionOptions: [
      { label: 'All', value: -1 },
      { label: 'Undefined', value: 0 },
      { label: 'Completed', value: 1 },
      { label: 'Pending', value: 2 },
      { label: 'Reversed', value: 3 },
      { label: 'Error', value: 4 },
      { label: 'Canceled', value: 5 },
      { label: 'Hold', value: 6 },
      { label: 'Insufficient', value: 7 },
      { label: 'Fraud', value: 8 },
      { label: 'Processed', value: 9 }
    ],
    Id:'Id',
    /* START SCA LEFT SIDEBAR MENU */ 
    UserDashboard: 'Kullanıcı Paneli',
    MyDashboard: 'Kontrol Paneli',
    Profile: 'Profil',
    Accounts:'Hesaplar',
    //--//
    Transaction:'İşlemler',
    History:'Geçmiş',
    Deposit:'Para Yatırma',
    Withdrawal:'Para Çekme',
    Transfer:'Transfer',
    /* END SCA LEFT SIDEBAR MENU */ 

    /* Start Dashboard Panel */ 
    BALANCE:'BAKIYE',
    CREDIT:'BONUS',
    EQUITY:'VARLIK',
    MARGIN:'MARJIN',
    MARGIN_LEVEL:'MARJIN SEVIYESI',
    MARGIN_FREE:'SERBEST MARJIN',
    /* End Dashboard Panel */ 

    /* Start Dashboard Items */ 
    DashboardItems:'Kullanıcı Tablosu Ögeleri',
    recordType:'Kayıt Tipi',
    todayValue:'Günlük Değer',
    thisMonthValue:'Aylık Değer',
    lastMonthValue:'Geçen Ay Değer',
    AveragePerMonthValue:'Ortalama Aylık Değer',
    Lot:'Lot',
    Agent:'Agent',
    OpenSwap:'Açık Swap',
    ClosedSwap:'Kapanmış Swap',
    ClosedProfit:'Kapanmış Profit',
    /* End Dashboard Items */ 

    /* Start Control Panel Profile */
    Information:'Bilgi',
    ContactInfo:'İletişim Bilgileri',
    Notifications:'Bildirimler',
    ChangePassword:'Parolayı Değiştir',
    /* End Control Panel Profile */

    /* Start Accounts Links */
    RealAccounts:'Gerçek Hesaplar',
    DemoAccounts:'Demo Hesaplar',
    /* End Accounts Links */

    /* Start Transaction */
    Amount:'Tutar',
    Type:'İşlem Türü',
    Status:'Durum',
    Currency:'Para Birimi',
    Fee:'Ücret',
    ProviderName:'Sağlayıcı',
    MethodName:'Yöntem',
    CreatedDate:'Oluşturulma Tarihi',
    Note:'Not',
    // -- Start TRANSFER -- //
    FromAccount:'Çıkış Hesabı Seçiniz',
    ToAccount:'Giriş Hesabı Seçiniz',
    Description:'Açıklama',
    // -- End TRANSFER -- //
    // -- Start Deposit -- //
    MakeDeposit:'Para Yatır',
    ProviderMethods:'Sağlayıcı Yöntemleri',
    // -- End Deposit -- //
    // -- Start Withdrawal -- //
    ExtraInfo: 'Ek Bilgi',
    Reason:'Sebep',
    MinAmount:'Minimum Tutar',
    MaxAmount:'Maksimum Tutar',
    WithdrawalCreditCard:'Kredi Kartı ile Para Çekme',
    WithdrawalInfoHeader:'Lütfen Dikkat',
    WithdrawalInfoText:'İşlem / IB hesabının para birimi, banka / kart / ödeme sistemi hesabının para biriminden farklıysa, çekilen miktar işleme göre dönüştürülür.',
    WithdrawalInfoHeader2:'Aşağıdaki örnekler, para çekme talepleriniz için sınırlamalarımızı gösterecektir:',
    WithdrawalInfoText2:'Müşterilerin fonlarını dijital hesaplarından para çekmelerine izin veriyoruz, ancak daha önce para yatırdıkları hesaplardan para çekebilirler. Dijital para hesap numarası, para yatırıldığı zamanki ile aynı olmalıdır. Herhangi bir para çekme işlemi yapılabilmesi için, bu hesapların üzerindeki adın kayıtlarımızdaki müşterinin adıyla eşleşmesi gerekir. Bu sınırlamalarla müşterilerimizi dolandırıcılıktan koruyoruz.',
    WithdrawalInfoText3:'Hangi yatırım yöntemleri kullanarak para yatırırsanız, fonlarınızı aynı oranda çekmeniz gerekecektir. Örneğin, Skrill ile € 100, Neteller ile € 500 depozito ederseniz ve 400 € kar elde ederseniz, Skrill`e € 100 ila € 500, Neteller`a € 500 - € 900 çekebilirsiniz.',
    // -- End Withdrawal -- //
    /* End Transaction */
    SelectDate: 'Tarih Seç',
    DateFrom: 'Başlangıç Tarihi',
    DateTo: 'Bitiş Tarihi',
    OrderList:'İşlem Geçmişi',
    Next:'İleri',
    Back:'Geri',
    Submit:'Onayla',
    MakeWithdrawal:'Para Çek',
    Account:'Hesap',
    Name:'Ad Soyad',
    Group:'Grup',
    Balance:'Bakiye',
    Equity:'Varlık',
    Margin:'Marjin',
    MarginLevel:'Marjin Seviyesi',
    MarginFree:'Serbest Marjin',
    Leverage:'Kaldıraç',
    Comment:'Yorum',
    AccountId:'Hesap Id',
    New:'Ekle',
    Knowledge:'Bilgi',
    PasswordInfo:'Aşağıda görmüş olduğunuz parola kısmı müşteri panelinize girmiş olduğunuz parola içindir.',
    ConfirmPassword:'Parolayı Onayla',
    NewPassword:'Yeni Parola',
    OldPassword:'Eski Parola',
    Save:'Kaydet',
    Accept:'Onayla',
    Cancel:'İptal Et',
    UserName:'Kullanıcı Adı',
    FirstName:'Ad',
    LastName:'Soyad',
    BirthDate:'Doğum Tarihi',
    Gender:'Cinsiyet',
    NationalCode:'Ülke Kodu',
    Man:'Erkek',
    Woman:'Kadın',
    Other:'Diğer',
    CommunicationType:'İletişim Türü',
    Email: 'E-Mail',
    Emails:'E-Mailler',
    EnterTheNewEmail:'Yeni E-Postayı Girin :',
    Phone:'Telefon',
    Phones:'Telefonlar',
    EnterTheNewPhone:'Yeni Telefon Girin :',
    Apps: 'Apps',
    Calendar: 'Takvim',
    User: 'Kullanıcı',
    Logout:'Çıkış yap',
    UserSettings: 'Kullanıcı Ayarları',
    Search: 'Ara',
    demoText: 'Cake sesame snaps cupcake gingerbread danish I love gingerbread. Apple pie pie jujubes chupa chups muffin halvah lollipop. Chocolate cake oat cake tiramisu marzipan sugar plum. Donut sweet pie oat cake dragée fruitcake cotton candy lemon drops.',
    orientation: {
      label: 'Interested in ',
      items: [
        {
          value: '1',
          label: 'Men'
        }, {
          value: '2',
          label: 'Women'
        }, {
          value: '3',
          label: 'Both'
        }
      ]
    },
    depositDescriptions:{
      'WebMoney':[
        {
          id: 1,
          isBold: false,
          text: 'Tüm Webmoney mevduat için para transferi #Z951026725117 ve açıklama bölümüne işlem hesabı numarasını ekleyin.'
        },
        {
          id: 2,
          isBold: false,
          text: 'İşlemi tamamladıktan sonra aşağıdaki formu doldurun.'
        },
        {
          id: 3,
          isBold: false,
          text: 'Lütfen aşağıdaki yorum kutusuna ek bilgi (koruma kodu / dönem, işlem numarası vb.) Ekleyin.'
        }
      ],
      'BankWire':[
        {
          id: 1,
          isBold: false,
          text: 'Banka havalesi ile para yatırmak için, lütfen aşağıdaki formu doldurun, işlem hesap numaranızı seçin ve yatırmak istediğiniz tutarı girin.'
        },
        {
          id: 2,
          isBold: false,
          text: 'Havale ile minimum depozit 100 DOLAR`dır.'
        },
        {
          id: 3,
          isBold: false,
          text: 'Havalelerde herhangi bir kesinti olmamaktadır.'
        },
        {
          id: 4,
          isBold: false,
          text: 'Bununla birlikte, bir muhabir banka ücreti uygulanabilir ve bu nedenle, ticaret hesabınıza yatırılan tutar, gönderdiğiniz tutardan düşük olabilir.'
        },
        {
          id: 5,
          isBold: false,
          text: 'Banka havalesi bilgilerini almak için lütfen finans@n1cm.com ile iletişime geçin. Lütfen, iletişim için kayıt e-postanızı kullanın.'
        }
      ],
      'CreditDebitCard':[
        {
          id: 1,
          isBold: false,
          text: 'Sabit Ücret: 0.2 $'
        },
        {
          id: 2,
          isBold: false,
          text: 'İşlem Ücreti: 2.3 $'
        },
        {
          id: 3,
          isBold: false,
          text: 'Minimum Depozito: 10 $'
        },
        {
          id: 4,
          isBold: false,
          text: 'Maksimum Depozito: 2000 $'
        },
        {
          id: 5,
          isBold: false,
          text: 'Geri ödeme ve kısmi iade ücreti: 0,5 €'
        }
      ],
      'CreditCard':[
        {
          id: 1,
          isBold: true,
          text: 'Kılavuz'
        },
        {
          id: 2,
          isBold: false,
          text: 'Herhangi bir satın alma / para yatırma işleminden önce kredi / banka kartınızda 3D Secure (SMS) koruması etkinleştirilmelidir.'
        },
        {
          id: 3,
          isBold: false,
          text: 'Para yatırma formunu doldurmadan önce, yurtdışı işlemlerde izin almak için lütfen kredi / banka kartı düzenleyicinizle veya bankanızla bağlantı kurun.'
        },
        {
          id: 4,
          isBold: true,
          text: 'Limitler'
        },
        {
          id: 5,
          isBold: false,
          text: 'E-posta adresi veya kredi / banka kartı başına günlük sınır: 6 denemedir.'
        },
        {
          id: 6,
          isBold: false,
          text: 'E-posta adresi veya kredi / banka kartı başına haftalık limit: 6 denemedir.'
        },
        {
          id: 7,
          isBold: false,
          text: 'E-posta adresi veya kredi / banka kartı başına aylık sınır: 9 denemedir.'
        },
        {
          id: 8,
          isBold: true,
          text: '3D Güvenlik Sistemi Nedir ?'
        },
        {
          id: 9,
          isBold: false,
          text: '3D Secure nedir ve neden gereklidir ?'
        },
        {
          id: 10,
          isBold: false,
          text: '3D güvenli kimlik doğrulama veya 3DS olarak da anılan 3D güvenli, ilk olarak Visa tarafından (Verified-by-Visa) 2001 yılında başlatılan bir dolandırıcılık önleme önlemidir.'
        },
        {
          id: 11,
          isBold: false,
          text: 'Kart ödemeleri alırken ek bir güvenlik katmanı görevi görür. Müşterilerinize çevrimiçi alışveriş yapmadan önce güvenli bir kimlik doğrulama adımı sağlar; Kartla ödeme sahtekarlığına karşı korunmaya yardımcı olmak için doğru kart bilgilerini kullandıklarından emin olmak.'
        },
        {
          id: 12,
          isBold: false,
          text: 'Visa`nın yanı sıra, şu anda Mastercard (Mastercard Secure Code olarak) ve American Express (American Express SafeKey olarak) dahil olmak üzere büyük banka ve kredi kartı düzenleyicileri tarafından desteklenmekte ve tanınmaktadır.'
        }
      ]
    },
    withdrawalDescriptions:{
      'CreditDebitCard':[
        {
          id: 1,
          isBold: true,
          text: 'Kredi Kartı Para Çekme'
        },
        {
          id: 2,
          isBold: false,
          text: 'Lütfen dikkat edin, kartla para çekme işlemi geri ödeme olarak işlenir, bu nedenle bu seçeneği yalnızca kaldırma yöntemi olarak ve başlangıçta yatırdığınız miktara kadar kartınıza iade edebilirsiniz. Paranın banka hesabınıza aktarılması 1 - 14 iş günü sürebilir.'
        },
        {
          id: 3,
          isBold: false,
          text: 'Kartla para çekme işleminin geri ödeme başına 15 $ tutarında sabit bir ücreti vardır. Bunun yerine “Skrill”, “Neteller” veya “kripto para birimleri” gibi diğer ödeme seçeneklerini kullanabilirsiniz.'
        }
      ]
    }
  },
  en: {
    /* Start Transaction - History */
    AccountNo: 'Account Number',
    TransactionStatus :'Transaction Status',
    /* End Transaction - History */

    /* Accounts Password */
    ChangeMTPassword: 'Change Meta Trader Password',
    ServerType: 'Server Type',
    ChangeMasterPassword: 'Change Master Password',
    ChangeInverstorPassword: 'Change Inverstor (Read Only) Password',
    /* End Accounts */

    /* Accounts Recharge demo account */
    RechargeDemoAccount: 'Recharge Demo Account',
    /* End Accounts Recharge demo account */

    /* Accounts Leverage */
    ChangeLeverage: 'Change Leverage',
    /* End Accounts Leverage */

    transactionOptions: [
      { label: 'All', value: -1 },
      { label: 'Undefined', value: 0 },
      { label: 'Completed', value: 1 },
      { label: 'Pending', value: 2 },
      { label: 'Reversed', value: 3 },
      { label: 'Error', value: 4 },
      { label: 'Canceled', value: 5 },
      { label: 'Hold', value: 6 },
      { label: 'Insufficient', value: 7 },
      { label: 'Fraud', value: 8 },
      { label: 'Processed', value: 9 }
    ],
    Id:'Id',
    /* START SCA LEFT SIDEBAR MENU */ 
    UserDashboard: 'User Dashboard',
    MyDashboard: 'My Dashboard',
    Profile: 'Profile',
    Accounts:'Accounts',
    //--//
    Transaction:'Transaction',
    History:'History',
    Deposit:'Deposit',
    Withdrawal:'Withdrawal',
    Transfer:'Transfer',
    /* END SCA LEFT SIDEBAR MENU */ 

    /* Start Dashboard Panel */ 
    BALANCE:'BALANCE',
    CREDIT:'CREDIT',
    EQUITY:'EQUITY',
    MARGIN:'MARGIN',
    MARGIN_LEVEL:'MARGIN LEVEL',
    MARGIN_FREE:'MARGIN FREE',
    /* End Dashboard Panel */ 

    /* Start Dashboard Items */ 
    DashboardItems:'Dashboard Items',
    recordType:'Record Type',
    todayValue:'Today Value',
    thisMonthValue:'This Month Value',
    lastMonthValue:'Last Month Value',
    AveragePerMonthValue:'Average Per Month Value',
    Lot:'Lot',
    Agent:'Agent',
    Commission:'Commission',
    OpenSwap:'Open Swap',
    ClosedSwap:'Closed Swap',
    ClosedProfit:'Closed Profit',
    /* End Dashboard Items */ 

    /* Start Control Panel Profile */
    Information:'Information',
    ContactInfo:'Contact Info',
    Notifications:'Notifications',
    ChangePassword:'Change Password',
    /* End Control Panel Profile */

    /* Start Accounts Links */
    RealAccounts:'Real Accounts',
    DemoAccounts:'Demo Accounts',
    /* End Accounts Links */

    /* Start Transaction */
    Amount:'Amount',
    Type:'Transaction Type',
    Status:'Status',
    Currency:'Currency',
    Fee:'Fee',
    ProviderName:'Provider Name',
    MethodName:'Method Name',
    CreatedDate:'Created Date',
    Note:'Note',
    // -- Start TRANSFER -- //
    FromAccount:'From Account',
    ToAccount:'To Account',
    Description:'Description',
    // -- End TRANSFER -- //
    // -- Start Deposit -- //
    MakeDeposit:'Make Deposit',
    ProviderMethods:'Provider Methods',
    // -- End Deposit -- //
    // -- Start Withdrawal -- //
    SelectDate: 'Select Date',
    DateFrom: 'Start Date',
    DateTo: 'End Date',
    ExtraInfo:'Extra Information',
    Reason:'Reason',
    MinAmount:'Minimum Amount',
    MaxAmount:'Maximum Amount',
    WithdrawalCreditCard:'Withdrawal Credit Card',
    WithdrawalInfoHeader:'Please note!',
    WithdrawalInfoText:'In case the currency of trading/IB account differs from the currency of the bank/card/payment system account, the withdrawal amount will be converted.',
    WithdrawalInfoHeader2:'The following examples will illustrate your limitations we have for withdrawal requests:',
    WithdrawalInfoText2:'We allow clients to withdraw their funds to digital currency accounts but only to the accounts they previously deposited funds from. Digital currency account number must be exactly the same as when funds were deposited. The name on these accounts must match clients name in our records before any withdrawal transaction can be executed. With these limitations we protect our customers from fraud.',
    WithdrawalInfoText3:'If you deposit funds using different deposit methods you will have to withdraw your funds in the same proportion. For example, if you deposit $100 through Skrill and $500 by Neteller, and you make $400 profit, then you will be able to withdraw $100-500 to Skrill and $500-900 by Neteller.',
    // -- End Withdrawal -- //

    /* End Transaction */

    OrderList:'Order List',
    Next:'Next',
    Back:'Back',
    Submit:'Submit',
    MakeWithdrawal:'Make Withdrawal',
    Name:'Name',
    Group:'Group',
    Balance:'Balance',
    Equity:'Equity',
    Margin:'Margin',
    MarginFree:'Margin Free',
    MarginLevel:'Margin Level',
    Leverage:'Leverage',
    Account:'Account',
    AccountId:'Account Id',
    New:'New',
    Knowledge:'Knowledge',
    PasswordInfo:'The password part you see below is for the password you entered in your customer panel.',
    ConfirmPassword:'Confirm Password',
    NewPassword:'New Password',
    OldPassword:'Old Password',
    Save:'Save Changes',
    Accept:'Accept',
    Cancel:'Cancel',
    Comment:'Comment',
    UserName:'User Name',
    FirstName:'First Name',
    LastName:'Last Name',
    BirthDate:'Birth Date',
    Gender:'Gender',
    NationalCode:'National Code',
    Man:'Man',
    Woman:'Woman',
    Other:'Other',
    CommunicationType:'Communication Type',
    Email: 'Email',
    Emails:'Emails',
    EnterTheNewEmail:'Enter The New Email :',
    Phone:'Phone',
    Phones:'Phones',
    EnterTheNewPhone:'Enter The New Phone :',
    Apps: 'Apps',
    Calendar: 'Calendar',
    User: 'User',
    Logout:'Logout',
    UserSettings: 'User Settings',
    Search: 'Search',
    demoText: 'Cake sesame snaps cupcake gingerbread danish I love gingerbread. Apple pie pie jujubes chupa chups muffin halvah lollipop. Chocolate cake oat cake tiramisu marzipan sugar plum. Donut sweet pie oat cake dragée fruitcake cotton candy lemon drops.',
    orientation: {
      label: 'Interested in ',
      items: [
        {
          value: '1',
          label: 'Men'
        }, {
          value: '2',
          label: 'Women'
        }, {
          value: '3',
          label: 'Both'
        }
      ]
    },
    depositDescriptions:{
      'WebMoney':[
        {
          id: 1,
          isBold: false,
          text: 'For all Webmoney deposits, kindly transfer the fund to purse #Z951026725117 and add the trading account number in the description section.'
        },
        {
          id: 2,
          isBold: false,
          text: 'Fill out the form below after completing the transaction.'
        },
        {
          id: 3,
          isBold: false,
          text: 'Please add additional information (protection code/period, transaction number, etc...) to the comment box at below.'
        }
      ],
      'BankWire':[
        {
          id: 1,
          isBold: false,
          text: 'To deposit by wire transfer, please fill out the form below, select your trading account number and enter the amount you wish to deposit.'
        },
        {
          id: 2,
          isBold: false,
          text: 'Minimum deposit via wire transfer is $500.'
        },
        {
          id: 3,
          isBold: false,
          text: 'Please note that we do not charge fees for deposits by wire.'
        },
        {
          id: 4,
          isBold: false,
          text: 'However, correspondent banks fees may apply and as the result the amount credited to your trading account maybe less than the amount you sent.'
        },
        {
          id: 5,
          isBold: false,
          text: 'To receive the bank wire information, please contact finance@n1cm.com. Kindly, use your registration email for the correspondent.'
        }
      ],
      'CreditDebitCard':[
        {
          id: 1,
          isBold: false,
          text: 'Fixed fee: $0.2'
        },
        {
          id: 2,
          isBold: false,
          text: 'Transaction fee: %2.3'
        },
        {
          id: 3,
          isBold: false,
          text: 'Minimum Deposit: $10'
        },
        {
          id: 4,
          isBold: false,
          text: 'Maximum Deposit: $2000'
        },
        {
          id: 5,
          isBold: false,
          text: 'Refund, and partial refund fee: €0.5'
        }
      ],
      'CreditCard':[
        {
          id: 1,
          isBold: true,
          text: 'Guide'
        },
        {
          id: 2,
          isBold: false,
          text: '3D Secure (SMS) protection must be activated on your credit/debit card before any purchase/deposit.'
        },
        {
          id: 3,
          isBold: false,
          text: 'Before filling out the deposit form, please contact your credit/debit card issuer or your bank to get permission on abroad transactions.'
        },
        {
          id: 4,
          isBold: true,
          text: 'Limits'
        },
        {
          id: 5,
          isBold: false,
          text: 'Daily limit per email address or credit/debit card: 6 attempts'
        },
        {
          id: 6,
          isBold: false,
          text: 'Weekly limit per email address or credit/debit card: 6 attempts'
        },
        {
          id: 7,
          isBold: false,
          text: 'Monthly limit per email address or credit/debit card: 9 attempts'
        },
        {
          id: 8,
          isBold: true,
          text: 'What is 3D Secure System ?'
        },
        {
          id: 9,
          isBold: false,
          text: 'What is 3D Secure, and why is it needed?'
        },
        {
          id: 10,
          isBold: false,
          text: '3D secure, also referred to as 3D secure authentication or 3DS, is a fraud prevention measure that was originally launched by Visa (as Verified-by-Visa) back in 2001.'
        },
        {
          id: 11,
          isBold: false,
          text: 'It acts as an added layer of security when taking card payments. It gives your customers a secure authentication step before they can purchase shopping online; ensuring that they’re using the correct card details to help protect against card payment fraud.'
        },
        {
          id: 12,
          isBold: false,
          text: 'Alongside Visa, it is now backed and recognised by major debit and credit card issuers, including Mastercard (as Mastercard Secure Code) and American Express (as American Express SafeKey).'
        }
      ]
    },
    withdrawalDescriptions:{
      'CreditDebitCard':[
        {
          id: 1,
          isBold: true,
          text: 'CC Withdrawal'
        },
        {
          id: 2,
          isBold: false,
          text: 'Please be noticed, card withdrawals are processed as a refund, hence, you can use this option only as the removal method and up to your originally deposited amount back to your card. The process can take 1 - 14 business days for the funds to be posted on your bank account.'
        },
        {
          id: 3,
          isBold: false,
          text: 'Withdrawal by card has a fixed fee for $15 per refund. You may utilize other payout options such as "Skrill", "Neteller" or the "Cryptocurrencies" instead.'
        }
      ]
    }
  },
  de: {
    MyDashboard: 'Instrumententafel',
    Apps: 'Apps',
    Email: 'Email',
    Calendar: 'Kalender',
    Profile: 'Profil',
    User: 'Benutzer',
    UserSettings: 'Benutzereinstellungen',
    Search: 'Suche',
    demoText: 'Kuchen Sesam Schnaps Cupcake Lebkuchen Dänisch Ich liebe Lebkuchen. Apfelkuchen-Torte-Jujuben chupa chups muffin halvah Lutscher. Schokoladenkuchenhaferkuchen Tiramisu-Marzipanzuckerpflaume. Donut süße Kuchen Hafer Kuchen Dragée Obstkuchen Zuckerwatte Zitrone Tropfen.',
    orientation: {
      label: 'De_Interested in ',
      items: [
        {
          value: '1',
          label: 'DE_Men'
        }, {
          value: '2',
          label: 'DE_Women'
        }, {
          value: '3',
          label: 'DE_Both'
        }
      ]
    },
    Deposit: 'Deposit',
    depositDescriptions:{
      VISa:[
        {
          id: 1,
          isBold: true,
          text: 'de paragraph 01'
        },
        {
          id: 2,
          isBold: false,
          text: 'de paragraph 02'
        }
      ]
    },
    withdrawalDescriptions:{
      VISa:[
        {
          id: 1,
          isBold: true,
          text: 'de withdrawal paragraph 01'
        },
        {
          id: 2,
          isBold: false,
          text: 'de withdrawal paragraph 02'
        }
      ]
    }
  },
  fr: {
    MyDashboard: 'Tableau de bord',
    Apps: 'Applications',
    Email: 'Email',
    Calendar: 'Calendrier',
    Profile: 'Profil',
    User: 'Utilisateur',
    UserSettings: 'Paramètres utilisateur',
    Search: 'Chercher',
    demoText: 'Le gâteau au sésame s\'enclenche au petit pain au pain d\'épices danois J\'adore le pain d\'épices. Tarte aux pommes et jujubes chupa chups muffin halvah sucette. Tiramisu gâteau au chocolat gâteau d\'avoine tiramisu prune sucre. Donut tarte sucrée gâteau à l\'avoine dragée gouttes de fruits gâteau au citron en barbe à papa.',
    orientation: {
      label: 'De_Interested in ',
      items: [
        {
          value: '1',
          label: 'DE_Men'
        }, {
          value: '2',
          label: 'DE_Women'
        }, {
          value: '3',
          label: 'DE_Both'
        }
      ]
    },
    Deposit: 'Deposit',
    depositDescriptions:{
      VISa:[
        {
          id: 1,
          isBold: true,
          text: 'fr paragraph 01'
        },
        {
          id: 2,
          isBold: false,
          text: 'fr paragraph 02'
        }
      ]
    },
    withdrawalDescriptions:{
      VISa:[
        {
          id: 1,
          isBold: true,
          text: 'fr withdrawal paragraph 01'
        },
        {
          id: 2,
          isBold: false,
          text: 'fr withdrawal paragraph 02'
        }
      ]
    }
  }
}
